import { createSelector } from '@reduxjs/toolkit';
import { selectAllVariants } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { selectAllGroups, selectGroupById } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { selectPhotoById } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';

export const selectVariantByAttributes = createSelector([
    selectAllVariants,
    (_: PhotoPrintsPdpState, paperId: string) => paperId,
    (_: PhotoPrintsPdpState, paperId: string, sizeId: string) => sizeId,
    (_: PhotoPrintsPdpState, paperId: string, sizeId: string, borderId: string) => borderId
], (variants, paperId, sizeId, borderId) => {
    return variants.find(v => v!.paperId === paperId && v!.sizeId === sizeId && v?.borderId === borderId);
});

const selectGroupByPhotoId = createSelector([
    selectPhotoById,
    selectAllGroups
], (photo, groups) => {
    return groups.find(g => g.id === photo!.groupId)!;
});

export const selectVariantByPhotoId = createSelector([
    state => state,
    selectGroupByPhotoId
], (state, group) => {
    return selectVariantByGroupId(state, group.id);
});

export const selectVariantByGroupId = createSelector([
    selectAllVariants,
    selectGroupById
], (variants, group) => {
    return variants.find(v => v.id === group!.variantId)!;
});